import { NgModule } from '@angular/core';
import { CheckoutEventModule, CheckoutRootModule } from '@spartacus/checkout/base/root';
import { CheckoutB2BCoreModule } from '@spartacus/checkout/b2b/core';
import { CheckoutModule } from '@spartacus/checkout/base';
import { CheckoutComponentsModule } from '@spartacus/checkout/base/components';
import { CheckoutCoreModule } from '@spartacus/checkout/base/core';
import { CheckoutB2BModule } from '@spartacus/checkout/b2b';
import { CheckoutB2BComponentsModule } from '@spartacus/checkout/b2b/components';
import { CheckoutB2BOccModule } from '@spartacus/checkout/b2b/occ';
import { CheckoutB2BEventModule } from '@spartacus/checkout/b2b/root';
import { CheckoutOccModule } from '@spartacus/checkout/base/occ';
import { provideConfig } from '@spartacus/core';

const featureModules = [
  CheckoutRootModule,
  CheckoutModule,
  CheckoutComponentsModule,
  CheckoutCoreModule,
  CheckoutEventModule,
  CheckoutOccModule,

  CheckoutB2BCoreModule,
  CheckoutB2BModule,
  CheckoutB2BComponentsModule,
  CheckoutB2BOccModule,
  CheckoutB2BEventModule,
];

@NgModule({
  imports: [...featureModules],
  exports: [...featureModules],
  providers: [
    provideConfig({
      featureModules: {
        checkout: {
          module: () => import('@spartacus/checkout/b2b/root').then((m) => m.CheckoutB2BRootModule),
        },
      },
    }),
  ],
})
export class SpartacusCheckoutFeatureModule {}
